import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ElementRef,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  UntypedFormArray,
} from "@angular/forms";
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/common/utils';
import { Physician } from 'src/app/models/physician';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { RealTimeService } from 'src/app/service/websockets/realtime.service';
import Swal from 'sweetalert2';
// import Chart from 'chart.js';
import Chart from 'chart.js/auto';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-myfiles',
  templateUrl: './myfiles.component.html',
  styleUrls: ['./myfiles.component.css']
})
export class MyfilesComponent implements OnInit {
  @ViewChild('inputFile') myInputVariable: ElementRef;
  @ViewChild('PDFModal', { static: true } as any) PDFModal: TemplateRef<any>;
  @Input() drid;
  details: any;
  @ViewChild("inputFile")
  inputFile: ElementRef;
  aptType = Utils.APPOINTMENT_TYPE;
  aptStatus = Utils.APPOINTMENT_STATUS;
  physician: Physician;
  forms = {
    documentsForm: null,
  };
  physicians: any;
  documents: UntypedFormArray;
  disableSubmit: boolean = false;
  uploadedFiles: [File]
  maxSize = Utils.MAX_FILE_SIZE;
  pdfSrc: any;
  email: any;
  appointment: any;
  data: any;
  attachmentSignedUrl: string;
  Imagekey: string;
  @Input() getOrgDet;
  chart: Chart<"line", string[], string>;

  constructor(private service: VproService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private modal: NgbModal,
    private realTimeService: RealTimeService) {
    this.forms.documentsForm = this._formBuilder.group({
      documents: this._formBuilder.array([]),
    });
  }

  ngOnInit(): void {
    this.getAppointment();
    // this.createChart();

  }
  // createChart() {

  //   this.chart = new Chart("MyChart", {
  //     type: 'line', //this denotes tha type of chart

  //     data: {// values on X-Axis
  //       labels: ['2022-01-01', '2022-02-01', '2022-03-01', '2022-04-01',
  //         '2022-05-01', '2022-06-01', '2022-07-01', '2022-08-01',],
  //       datasets: [
  //         {
  //           label: "Appointments",
  //           data: ['467', '576', '572', '79', '92',
  //             '574', '573', '576'],
  //           backgroundColor: 'blue'
  //         }
  //       ]
  //     },
  //     options: {
  //       aspectRatio: 2.5
  //     }

  //   });
  // }
  // Get previous Document Function
  getAppointment() {
    this.data = {
      org_code: localStorage.getItem("orgcode"),
      getOrgDet: (localStorage.getItem("LogUsr")),
      drid: this.drid || JSON.parse(localStorage.getItem("uid")),
    }
    this.spinner.show();
    this.service.getAppointmentDetails(
      {
        u_id: this.data.drid, fields: ["doc_documents"]
      }
    ).subscribe(res => {
      this.appointment = res;
      this.spinner.hide();
      this.details = res;

      // display uploaded docs
      if (res && res.length > 0) {
        console.log("documents", res.documents);
        console.log("documents length", res.length);
        console.log("res1", res);

        this.documents = this.forms.documentsForm.get(
          "documents"
        ) as UntypedFormArray;
        res.forEach(doc => {
          this.documents.push(this.createDocument(doc.description, doc.key.split('/').pop(), doc.type ? doc.type : "", doc.previewUrl, true));
        });
        if (this.documents.length < 10) {
          this.documents.push(this.createDocument());
        }
        if (this.documents.length > 10) {
          this.disableSubmit = true;
        }
      } else {
        this.addingDocument(1);
      }
    }, error => {
      this.spinner.hide();
      this.showToast('error', "Something went wrong. Please try again.");
    });
  }

  // Create Document and Validation
  createDocument(description = "", name = "", type = "", previewUrl = "", readOnly = false): UntypedFormGroup {
    return this._formBuilder.group({
      description: [description, [Validators.required]],
      name: [name, [Validators.required]],
      type: [type],
      previewUrl: [previewUrl],
      readOnly: [readOnly]
    });
  }
  /** removing current speciality form list */
  public removingCurrentDocument(i: number): void {
    console.log("this.documents.length", this.documents.length)
    console.log("i", i)
    console.log("this.details", this.details.length + 1)
    if (this.documents.length === 1) {
      console.log(" this.inputFile.nativeElement.value", this.inputFile.nativeElement.value)
      this.inputFile.nativeElement.value = "";
      this.documents.reset();
    }
    else if (this.details.length + 1 === this.documents.length) {
      this.documents.removeAt(i);
      this.addingDocument(i);
    }
    else {
      this.documents.removeAt(i);
      console.log("this.uploadedFiles", this.uploadedFiles)
      if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
    }
  }

  // Add Document Function
  public addingDocument(i: number): void {
    if (this.documents && this.documents.length >= 10) {
      this.showToast('error', "Maximum 10 documents can be uploaded");
      return;
    }
    this.documents = this.forms.documentsForm.get(
      "documents"
    ) as UntypedFormArray;
    this.documents.push(this.createDocument());
  }



  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  // Document Limitation Function
  async selectFile(event, i) {
    console.log("event", event)
    let { target: { files } } = event;
    let [file] = files;
    let data = { u_id: this.data.drid.toString(), };
    console.log("file", file)

    if (file) {

      // console.log("event", event);
      if (file.size > this.maxSize) {
        this.showToast('error', "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      if (this.uploadedFiles && i < this.uploadedFiles.length) {
        this.uploadedFiles[i] = file;
      } else if (this.uploadedFiles) {
        this.uploadedFiles.push(file);
      } else {
        this.uploadedFiles = [file];
      }
      // Upload image in S3 Bucket
      await this.service.uploadFiles({
        u_id: this.data.drid.toString(), email: this.data.getOrgDet,
        file: { name: file.name, type: file.type }
      }, file).subscribe(res => {
        this.attachmentSignedUrl = res.value.signedUrl;
        this.Imagekey = res.value.key;
        data["contentType"] = file.type;
        data["message"] = this.Imagekey;
        this.realTimeService.send(data);
        this.spinner.hide();
      }, error => {
        this.spinner.hide();
        this.showToast('error', 'Something went wrong.Please try again !')
      })
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        let previewUrl = reader.result;
        this.documents.at(i).patchValue({ name: file.name, type: file.type, previewUrl: previewUrl });
      }
    }
    else {

      this.documents.at(i).patchValue({ name: '', type: '', previewUrl: '' });
    }

  }

  // // Remove Current Dcument Function
  // public removingCurrentDocument(i: number): void {


  //   if (this.documents.length === 1) {
  //     console.log("this.documents.length", this.documents.length)
  //     console.log(this.inputFile)
  //     console.log(this.inputFile.nativeElement)
  //     this.inputFile.nativeElement.value = "";
  //     this.documents.reset();
  //   } else {
  //     this.documents.removeAt(i);
  //     if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
  //   }

  //   // this.documents.removeAt(i);
  //   // if (this.uploadedFiles) this.uploadedFiles.splice(i, 1);
  // }

  // Image Preview Function
  previewDocument(i) {
    if (this.documents.at(i).value && this.documents.at(i).value.previewUrl && this.documents.at(i).value.previewUrl.length > 0) {
      if (this.documents.at(i).value.type && this.documents.at(i).value.type.length > 0 && this.documents.at(i).value.type.includes('/')) {
        let file = this.documents.at(i).value.type.split('/');
        if (file && file.length > 0) {
          let fileType = file[0];
          if (Utils.IMGFILE == fileType) {
            Swal.fire({
              imageUrl: this.documents.at(i).value.previewUrl,
              showConfirmButton: false,
              showCloseButton: true,
            })
          } else {
            this.pdfSrc = this.documents.at(i).value.previewUrl;
            console.log("preview", this.documents.at(i))
            console.log("this.documents.at(i).value.previewUrl", this.pdfSrc)
            this.modal.open(this.PDFModal, { size: 'lg', centered: true, backdrop: 'static' });
          }
        }
      }
    }
  }

  // All Documents save Function
  saveDocuments() {
    if (this.forms.documentsForm.valid) {
      // Swal.fire({
      //   title: 'On final submit, the documents cannot be removed',
      //   text: "Are you sure?",
      //   type: 'info',
      //   showCancelButton: true,
      //   buttonsStyling: true,
      //   confirmButtonClass: 'btn btn-primary',
      //   confirmButtonText: 'Yes',
      //   cancelButtonClass: 'btn btn-secondary'
      // }).then((result) => {
      //   if (result.value) {
      if (this.documents.value.length > 0) {
        let docs = [];
        this.documents.value.forEach(doc => {
          if (!doc.readOnly) {
            delete doc.previewUrl;
            delete doc.readOnly;
            console.log("-------------  docs  -----------------------------", docs)
            console.log("-------------  doc  -----------------------------", doc)
            docs.push(doc);
          }
        });
        // get signed url from backend to upload
        this.spinner.show();
        this.service.uploadDocDocs({
          u_id: this.data.drid.toString(), email: this.data.getOrgDet,
          documents: docs
        }, this.uploadedFiles).subscribe(res => {

          console.log("res", res)
          this.spinner.hide();
          this.showToast('success', 'Documents uploaded !');
          window.location.reload();
        }, error => {
          this.spinner.hide();
          this.showToast('error', 'Error in uploading documents. Please try again !')
          window.location.reload();
        })
      }
      //   }
      // })
    }
  }
  closeModal() {
    this.modal.dismissAll();
  }
}
